export default (options) => {
  const { meta, data } = options;
  const { url } = meta;

  if (url.endsWith('/api/v1/auth')) {
    const res = {};
    const isExternalUser = data.userType === 'TPUSER';
    data.permissions.forEach((item) => (res[item] = true));
    data.permissions = res;
    data.organizations = data.organizations || [];

    // 知识点特殊处理
    data.modules.forEach((module) => {
      module.uuid === 'KNOWLEDGE_POINT' && (module.uuid = 'KNOWLEDGE_REPO');
    });

    if (isExternalUser) {
      data.modules.push({
        name: '备课资源',
        subModules: [],
        uuid: 'PREPARATION',
      });
    }
  }

  return options;
};
